// extracted by mini-css-extract-plugin
module.exports = {"root":"np50wDs0","title":"nqOzTSR8","description":"aYpo3sLP","item":"i9t-CfiO","inset":"P03TeZJN","divide":"yvoNouuX"};